// extracted by mini-css-extract-plugin
export default {"modal":"ModalPopup_modal__lpgT3"};